import store from '../../../store'

const setDateFrom = (params) => {
  store.commit('SET_DATE_FROM', params)
}

const setDateTo = (params) => {
  store.commit('SET_DATE_TO', params)
}

const setDateFromStatic = (params) => {
  store.commit('SET_DATE_FROM_STATIC', params)
}

const setDateToStatic = (params) => {
  store.commit('SET_DATE_TO_STATIC', params)
}

const setDateFromActive = (params) => {
  store.commit('SET_DATE_FROM_ACTIVE', params)
}

const setDateToActive = (params) => {
  store.commit('SET_DATE_TO_ACTIVE', params)
}

const setDateRangeFromRes = (data) => {
  store.commit('SET_DATE_RANGE_RES', data)
}

const resetDateRange = () => {
  store.commit('RESET_DATE_RANGE')
}

const setValidDate = (position, value) => {
  store.commit('SET_VALID_DATE_' + position, value)
}

const setCheckDate = (value) => {
  store.commit('SET_CHECK_DATE', value)
}

const setDateGap = (data) => {
  store.commit('SET_DATE_GAP', data)
}

const setToDateArr = (obj) => {
  store.commit('SET_TO_DATE_ARR', obj)
}

const popFromDateArr = () => {
  store.commit('POP_FROM_DATE_ARR')
}

const resetDateArr = () => {
  store.commit('RESET_DATE_ARR')
}

export {
  setDateFrom,
  setDateTo,
  resetDateRange,
  setDateRangeFromRes,
  setDateGap,
  setDateFromStatic,
  setDateToStatic,
  setDateFromActive,
  setDateToActive,
  setToDateArr,
  setValidDate,
  setCheckDate,
  popFromDateArr,
  resetDateArr
}



// WEBPACK FOOTER //
// ./src/scripts/modules/store/date-filters-setters.js